import React, { useState } from 'react';
import { Camera, Upload } from 'lucide-react';
interface UploadStepProps {
  onNext: () => void;
}
type Tab = 'Breast' | 'Face' | 'Body';
export function UploadStep({
  onNext
}: UploadStepProps) {
  const [activeTab, setActiveTab] = useState<Tab>('Breast');
  const [measurement, setMeasurement] = useState('');
  // Mock state for uploaded photos to enable the button
  const [uploadedCount, setUploadedCount] = useState(0);
  const handleZoneClick = () => {
    if (uploadedCount < 3) {
      setUploadedCount(prev => prev + 1);
    }
  };
  const isReady = uploadedCount === 3 && measurement.length > 0;
  return <div className="flex flex-col h-full px-6 py-6 bg-white overflow-y-auto custom-scrollbar" data-id="element-55">
      {/* Tabs */}
      <div className="flex p-1 bg-[#f9fafb] rounded-xl border border-[#e5e7eb] mb-8" data-id="element-56">
        {(['Breast', 'Face', 'Body'] as Tab[]).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all ${activeTab === tab ? 'bg-white text-[#1a1a2e] shadow-sm border border-[#e5e7eb]/50' : 'text-[#6b7280] hover:text-[#1a1a2e]'}`} data-id="element-57">
            {tab}
          </button>)}
      </div>

      {/* Measurement Input */}
      <div className="mb-8" data-id="element-58">
        <label className="block text-sm font-semibold text-[#1a1a2e] mb-2" data-id="element-59">
          Nipple to nipple distance (cm)
        </label>
        <input type="number" value={measurement} onChange={e => setMeasurement(e.target.value)} placeholder="e.g. 21" className="w-full px-4 py-3 bg-[#f9fafb] border border-[#e5e7eb] rounded-xl text-[#1a1a2e] focus:outline-none focus:ring-2 focus:ring-[#b8a06a]/50 focus:border-[#b8a06a] transition-all" data-id="element-60" />
      </div>

      {/* Upload Zones */}
      <div className="mb-6" data-id="element-61">
        <div className="flex items-center justify-between mb-4" data-id="element-62">
          <label className="text-sm font-semibold text-[#1a1a2e]" data-id="element-63">
            Upload your photos
          </label>
          <span className="text-xs font-medium text-[#b8a06a] bg-[#b8a06a]/10 px-2 py-1 rounded-md" data-id="element-64">
            {uploadedCount}/3 uploaded
          </span>
        </div>

        <div className="grid grid-cols-3 gap-3" data-id="element-65">
          {['LEFT', 'FRONT', 'RIGHT'].map((label, idx) => {
          const isUploaded = uploadedCount > idx;
          return <button key={label} onClick={handleZoneClick} className={`flex flex-col items-center justify-center aspect-[3/4] rounded-xl border-2 border-dashed transition-all ${isUploaded ? 'border-[#b8a06a] bg-[#b8a06a]/5' : 'border-[#e5e7eb] bg-[#f9fafb] hover:border-[#b8a06a]/50 hover:bg-gray-50'}`} data-id="element-66">
                {isUploaded ? <div className="w-8 h-8 rounded-full bg-[#b8a06a] flex items-center justify-center text-white mb-2" data-id="element-67">
                    <Upload className="w-4 h-4" data-id="element-68" />
                  </div> : <div className="w-8 h-8 rounded-full bg-white shadow-sm border border-[#e5e7eb] flex items-center justify-center text-[#6b7280] mb-2" data-id="element-69">
                    <Camera className="w-4 h-4" data-id="element-70" />
                  </div>}
                <span className={`text-xs font-bold tracking-wider ${isUploaded ? 'text-[#b8a06a]' : 'text-[#6b7280]'}`} data-id="element-71">
                  {label}
                </span>
              </button>;
        })}
        </div>
        <p className="text-xs text-[#6b7280] text-center mt-4" data-id="element-72">
          Supported formats: JPG, PNG, HEIC
        </p>
      </div>

      {/* Action */}
      <div className="mt-auto pt-6" data-id="element-73">
        <button onClick={onNext} disabled={!isReady} className={`w-full py-4 rounded-xl font-semibold transition-all ${isReady ? 'bg-[#b8a06a] hover:bg-[#a08d5a] text-white shadow-lg shadow-[#b8a06a]/20 active:scale-[0.98]' : 'bg-[#f3f4f6] text-[#9ca3af] cursor-not-allowed'}`} data-id="element-74">
          Create my 3D
        </button>
      </div>
    </div>;
}